import React from 'react';
export function UrgencyBar() {
  return <div className="w-full bg-[#EE6A4D] text-white text-center text-xs md:text-sm font-black py-2 px-4" data-id="element-171" data-mp="m2yqe5xn89qc">
      🔥 Acceso inmediato + 2 Bonus Premium de regalo
    </div>;
}